import { type ReactNode } from 'react';

import styles from './providerPageLayout.module.scss';

export type ProviderPageLayoutProps = {
  /** Page content */
  children: ReactNode;
  /** Optional additional class name */
  className?: string;
};

/**
 * ProviderPageLayout – Consistent layout wrapper for provider dashboard pages.
 *
 * Provides standardized padding across all provider pages.
 *
 * @example
 * ```tsx
 * <ProviderPageLayout>
 *   <ProviderPageHeader title="Waitlists" />
 *   <TileGrid>...</TileGrid>
 * </ProviderPageLayout>
 * ```
 */
export function ProviderPageLayout({
  children,
  className
}: ProviderPageLayoutProps) {
  return (
    <div
      className={[styles.providerPageLayout, className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
